/**
 * @fileoverview Selo "Triagem 2/3" no cabeçalho do ticket, quando há triagem
 * em andamento. Abre o painel do contato na aba Triagem.
 */

import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { ListChecks } from "lucide-react";

import { i18n } from "../../translate/i18n";
import { tokens } from "./styles";

const useStyles = makeStyles((theme) => {
  const c = tokens(theme.palette.type === "dark");
  return {
    badge: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      height: 28,
      padding: "0 10px",
      borderRadius: 999,
      border: `1px solid ${c.inputBorder}`,
      background: "transparent",
      color: c.textPrimary,
      fontSize: 12,
      fontWeight: 600,
      fontFamily: "inherit",
      cursor: "pointer",
      whiteSpace: "nowrap",
      "&:hover": { background: c.hover },
      "& svg": { width: 14, height: 14, strokeWidth: 1.75 },
    },
    compact: { padding: "0 8px", gap: 4 },
    attention: { color: c.warn, borderColor: c.warnBorder },
  };
});

const TriageBadge = ({ session, onClick }) => {
  const classes = useStyles();
  const theme = useTheme();
  // No celular o cabeçalho é estreito: só o ícone e o progresso.
  const compact = useMediaQuery(theme.breakpoints.down("xs"));
  if (!session) return null;
  const { done, total } = session.progress || { done: 0, total: 0 };
  return (
    <Tooltip title={i18n.t("triage.badgeTooltip")}>
      <button
        type="button"
        className={`${classes.badge} ${compact ? classes.compact : ""} ${session.attentionReason ? classes.attention : ""}`}
        onClick={onClick}
        aria-label={i18n.t("triage.badge", { done, total })}
      >
        {/* Tamanho no style: o cabeçalho do ticket força 18px em todo svg. */}
        <ListChecks style={{ width: 14, height: 14 }} />
        {compact ? `${done}/${total}` : i18n.t("triage.badge", { done, total })}
      </button>
    </Tooltip>
  );
};

export default TriageBadge;
